module.exports = __webpack_public_path__ + "img/exide-life.16578845.png";